import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { CampaignService } from "../services/Campaign.service";
import { FINANCE_INFLUENCER_QUERY_KEY } from "../contsants";

export function useDeleteLedger(campaignInfluencerId: string) {
  const {
    mutate: deleteLedger,
    isLoading: isDeleting,
    isSuccess: isDeleted,
    variables,
  } = useMutation<{ ledgerId: string }>({
    mutationFn: async ({ ledgerId }) => {
      return await CampaignService.deleteLedger(
        campaignInfluencerId,
        ledgerId
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...FINANCE_INFLUENCER_QUERY_KEY(campaignInfluencerId)],
      });
      // TODO: Invalidate relevant queries here
    },
    options: {},
  });

  return {
    deleteLedger,
    isDeleting,
    isDeleted,
    variables,
  };
}
